const findSlotByName = (slots, name = "Barra") =>
  slots.find(slot => slot.name === name);

const findSlotById = (slots, slotId) =>
  slots.find(slot => slot.id === slotId);

export { findSlotByName, findSlotById };
